import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "./common/Header";
import Sidebar from "./common/Sidebar";
import Select from 'react-select';
import Network from "../utils/Network";
import { Urls } from "../utils/Constants";
import Loader from "./common/Loader";
import ErrorSuccessModal from "./common/modal/errorsuccessmodal";
import RechargeConfirmModal from "./common/modal/rechargeconfirmmodal";

export default function Recharge() {
  const { type } = useParams();
  const titleMap = {
    prepaid: 'Prepaid Recharge',
    dth: 'DTH Recharge',
    postpaid: 'Postpaid Recharge',
  };
  const title = titleMap[type] || 'Prepaid Recharge'; // fallback
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [modalMsg, setModalMsg] = useState("");
  const [showErrorSuccessModal, setShowErrorSuccessModal] = useState(0);
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState("");
  const [mobile, setMobile] = useState("");
  const [amount, setAmount] = useState("");
  const [isErrorFlag, setIsErrorFlag] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(0);

  const openModal = (type) => {
    switch(type){
      case 'Error':
        setIsErrorFlag(1);
        setShowErrorSuccessModal(1);
      break;
      case 'Success':
        setIsErrorFlag(0);
        setShowErrorSuccessModal(1);
      break;
      case 'RechargeConfirm':
        setShowConfirmModal(1);
      break;
    }    
  };
  const closeModal = (type) => {
    if(type === 'Success' || type === 'Error'){
      setIsErrorFlag(0);
      setShowErrorSuccessModal(0);
    }else{
      setShowConfirmModal(0);
    }
  };

  useEffect(()=> {
    fetchProviders();
  },[])

  const fetchProviders = async() => {
    let formData = new FormData();
    const localStorageDataStr = localStorage.getItem('token');
    const item = JSON.parse(localStorageDataStr);
    formData.append("api_token", item.token);
    try {
      setLoading(true); // Show loader
      const response = await Network.post(Urls.baseUrlPostLogin + '/recharge/provider-list', formData);
      if (response?.data?.providers?.length > 0) {
        const options = response.data.providers.map(item => ({
                value: item.provider_id,
                label: item.provider_name
            }));
        setProviders(options);
      }else{
        setProviders([]);
        const apiErrors = {providers : response.data.message};
        setErrors(apiErrors);
      }
    } catch (err) {
      console.log('error', err);
      setModalMsg(err);
      openModal('Error');
    } finally {
      setLoading(false); // Hide loader
    }
  }
  const handleProvider = (option) => {
    setSelectedProvider(option.value);
  }

  const handleSubmit = () => {
    const newErrors = errorHandling('recharge');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      openModal('RechargeConfirm');
    }
  }
  const rechargeNow = async(mpin) => {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("provider_id", selectedProvider);
      formData.append("recharge_number", mobile.trim());
      formData.append("amount", amount.trim());
      formData.append("mpin", mpin);
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/recharge/transaction', formData);
          if(response?.data?.status === 'success'){
            setModalMsg(response.data.message);
            closeModal('RechargeConfirm')
            openModal('Success');
          }else{
            const apiErrors = {mobile : response.data.message};
            setErrors(apiErrors);
          }
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
  }
  const errorHandling = (type) => {
    const errors = {};
    if (type === 'recharge') {
      if (selectedProvider === '') {
        errors.providers = 'Provider is required';
      }else if (!mobile.trim()) {
        errors.mobile = 'Mobile is required';
      }else if (mobile.length !== 10) {
        errors.mobile = 'Mobile must be at least 10 digit long';
      }else if (!amount.trim()) {
        errors.amount = 'Amount is required';
      }else if (amount.includes("-")) {
        errors.amount = 'Please provide valid amount';
      }else if(amount < 10){
        errors.amount = 'Please provide valid amount greater then 10';
      }
    }
    return errors;
  };

  return (
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        {loading ?
        <Loader/> :
        <main className="adminuiux-content has-sidebar">
          <div className="container" id="main-content">
            <div className="row align-items-center">
            </div>
            {/* dashboard inner */}
            <div className="midde_cont">
              <div className="container-fluid">
                <div className="row column_title">
                  <div className="col-md-12">
                    <div className="page_title d-sm-flex">
                      <h2>Recharge</h2>
                    </div>
                  </div>
                </div>
                <div className="row match-height">
                  <div className="col-md-12 mt-3">
                    {Object.entries(titleMap).map(([key, label]) => (
                      <Link
                        to={`/recharge/${key}`}
                        className={`btn btn-${type === key ? 'primary' : 'outline-dark'} square mr-1 mb-1 waves-effect waves-light`}
                      >
                        {label}
                      </Link>
                    ))}
                  </div>
                  <div className="col-md-5 col-12 mt-3">
                    <div className="card bd-0 shadow-base adminuiux-card">
                      <div className="card-header tx-medium bd-0 tx-white" style={{ padding: "0.75rem 1.25rem" }}>
                        {title}
                      </div>                      
                        <div className="card-body">
                              <div className="form-group">
                                <label htmlFor="first-name-vertical">Provider</label>
                                <Select className="custom-dropdown" onChange={handleProvider} options={providers}/>
                                {errors.providers && (
                                  <span className="error-message">
                                    {errors.providers}
                                  </span>
                                )}
                              </div>
                              <div className="form-group">
                                <label htmlFor="contact-info-vertical">
                                  Mobile Number
                                </label>
                                <input
                                  type="text"
                                  id="number"
                                  className="form-control"
                                  placeholder="Mobile Number"
                                  value={mobile}                                  
                                  onChange={(e) => { setMobile(e.target.value) }}
                                />
                                {errors.mobile && (
                                  <span className="error-message">
                                    {errors.mobile}
                                  </span>
                                )}
                              </div>                            
                              <div className="form-group">
                                <label htmlFor="email-id-vertical">Amount</label>
                                <input
                                  type="text"
                                  id="amount"
                                  className="form-control"
                                  placeholder="Amount"
                                  value={amount}
                                  onChange={(e) => { setAmount(e.target.value) }}
                                />
                                {errors.amount && (
                                  <span className="error-message">
                                    {errors.amount}
                                  </span>
                                )}
                              </div>
                              <button
                                id="btn-confirm"
                                className="btn btn-primary btn-sm tx-13 mr-1 mb-1 waves-effect waves-light"
                                onClick={handleSubmit}
                              >
                                Pay Now
                              </button>
                          </div>                        
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*recharge confirm modal */}
            {/* Modal */}
            {showErrorSuccessModal === 1 &&
              <ErrorSuccessModal
                title={isErrorFlag === 0 ? 'Success' : 'Error'}
                msg={modalMsg}
                closeModal={closeModal}
              />
            }
            {showConfirmModal === 1 &&
              <RechargeConfirmModal
                title="Confirm Your Recharge Detail"
                mobile={mobile}
                provider={selectedProvider}
                amount={amount}
                rechargeNow={rechargeNow}
                closeModal={closeModal}
              />
            }
          </div>
        </main>
        }
      </div>
    </>
  );
}